module.exports = __webpack_public_path__ + "static/slick2-682ac4c248708250e3d763f6b6552300.png";